import { lazy } from 'react';

const LazySignIn = lazy(() => import('./sign-in'));
export default LazySignIn;
